import { ColDef } from "ag-grid-community";
import { jiraIssuesColumnDef } from "../common/jiraIssuesColumnDef";
import { tagsColumnDef } from "../common/tagsColumnDef";
import { smartTagsColumnDef } from "../common/smartTagsColumnDef";
import { resourceAccountColumnDef } from "../common/resourceAccountColumnDef";
import { resourceTotalSpendColumnDef } from "../common/resourceTotalSpendColumnDef";
import { forecastedEOMColumnDef } from "../common/forecastedEOMColumnDef";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { taskColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/taskColumnDef";
import { billingCostColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/billingCostColumnDef";
import { getListingPriceColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/listingPriceColumnDef";

export const ipColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef("IP", "ip"),

  forecastedEOMColumnDef,
  billingCostColumnDef,
  getListingPriceColumnDef("ip"),

  resourceAccountColumnDef,

  resourceTotalSpendColumnDef,

  { field: "resource.name", headerName: "Name" },

  { field: "resource.availability_zone", headerName: "Av. Zone" },

  tagsColumnDef,
  smartTagsColumnDef,
  taskColumnDef,
  jiraIssuesColumnDef,
];
